<template>
  <div
    v-if="log.length > 0"
    class="log-wrapper"
    @mouseenter="showTable = true"
    @mouseleave="showTable = false"
  >
    <span><img class="log-icon" src="/img/tasks/clock.svg"/></span>

    <div v-if="showTable" class="log-table" @mouseenter="showTable = false">
      <div class="table-responsive">
        <table class="table ">
          <tbody>
            <tr v-for="(item, idx) in log" :key="item.id">
              <td v-if="idx < 7">{{ formatDateTable(item.created_at) }}</td>
              <td v-if="idx < 7">{{ item.created_at | shortTime }}</td>
              <td v-if="idx < 7">{{ item.user.full_name }}</td>
              <td v-if="idx < 7"><span v-html="item.prev_content"></span></td>
              <td v-if="idx < 7"><span v-html="item.new_content"></span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "TaskLog",
  props: {
    log: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showTable: false
    };
  },
  created() {},
  methods: {
    removeHtml(tag) {
      return tag.replace(/<\/?[^>]+(>|$)/g, " ");
    },
    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM/YY ");
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY");
    }
  }
};
</script>

<style scoped>
.log-icon {
  width: 21px;
  cursor: pointer;
  margin-top: -1px;
}
.log-wrapper {
  //position:absolute;
  margin-left: 5px;
  z-index: 2;
}
.log-table {
  position: absolute;
  bottom: 124px;
  right: 80px;
  width: max-content;
  z-index: 10001;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
.table-responsive {
  margin-bottom: -18px;
  border-radius: 5px;
}
</style>
